export default __webpack_public_path__ + "static/media/apple.54f6d312.svg";